import React from 'react';

export default function useCustomForm<V=string, E=string[], Q=null>({
    defaultValue,
    validate = () => null,
} : {
    defaultValue: V,
    validate?: (value: V, options: Q, error: E|null) => E|null,
}) : [
    V, E|null, (value: V, options: Q) => void, (error: E|null) => void,
] {
    type S = { value: V, error: E|null };
    type A = { type: 'setValue', value: V, options: Q }|{ type: 'setError', error: E|null };
    const initialState: S = {
        value: defaultValue,
        error: null,
      };
      const reducer = (lastState: S, action: A): S => {
        switch (action.type) {
          case 'setValue':
            return { ...lastState, value: action.value, error: validate(action.value, action.options, lastState.error) };
          case 'setError':
            return { ...lastState, error: action.error };
          default:
            throw new Error();
        }
      };
      const [state, dispatcher] = React.useReducer(reducer, initialState);
      const value = React.useMemo(() => state.value, [state.value]);
      const error = React.useMemo(() => state.error, [state.error]);
      const setValue = React.useCallback((value: V, options: Q): void => {
        dispatcher({ type: 'setValue', value, options });
      }, []);
      const setError = React.useCallback((error: E|null): void => {
        dispatcher({ type: 'setError', error });
      }, []);
      return [value, error, setValue, setError];
}

export function validateField<V>(validation: [string, string, string, (value: V) => boolean][], name: string, value: V): { [ruleName: string]: string } {
  const error: { [ruleName: string]: string } = {};
  validation.forEach(([fieldName, ruleName, message, rule]) => {
    if (fieldName === name && !rule(value)) {
      error[ruleName] = message;
    }
  });
  return error;
}
